/**
 * Patient Status Enum
 *
 * Values synced with backend PatientStatusEnum.
 * @see backend/src/backend/db/constants/patient_status.py
 *
 * Backend values:
 * - ACTIVE = 1
 * - INACTIVE = 2
 */
import { intl } from "dmsbasereact";

export const PatientStatusEnum = {
    ACTIVE: 1,
    INACTIVE: 2
};

export const PatientStatus = {
    getText: (code) => {
        switch (code) {
            case PatientStatusEnum.ACTIVE:
                return intl.get("Active").d("Active");
            case PatientStatusEnum.INACTIVE:
                return intl.get("PatientStatus.Inactive").d("Inactive");
            default:
                return intl.get("PatientStatus.Unknown").d("Unknown");
        }
    },
    getColor: (code) => {
        switch (code) {
            case PatientStatusEnum.ACTIVE:
                return "success";
            case PatientStatusEnum.INACTIVE:
                return "error";
            default:
                return "default";
        }
    }
};

/**
 * Get patient status options for select components
 * @returns {Array} Array of {value, label} objects
 */
export const getPatientStatusOptions = () => [
    { value: PatientStatusEnum.ACTIVE, label: PatientStatus.getText(PatientStatusEnum.ACTIVE) },
    { value: PatientStatusEnum.INACTIVE, label: PatientStatus.getText(PatientStatusEnum.INACTIVE) }
];
